export default () => {
  const pageMenu = document.querySelector('.page-menu__menu');
  if (pageMenu) {
    const calcPageMenuWidth = () => {
      let width = 0;
      const menuItems = document.querySelector('#menu-main-navigation').children;
      for (let i = 0; i < menuItems.length; i++) {
        width += menuItems[i].offsetWidth;
      }
      pageMenu.style.width = width + 24 + 'px';
    }

    const setPageMenuWidth = () => {
      if (document.documentElement.clientWidth > 1080) {
        calcPageMenuWidth()
      } else {
        pageMenu.style.width = '';
      }
    }

    setPageMenuWidth()
    window.addEventListener('resize', setPageMenuWidth)
  }
}
